<template>
  <div></div>
</template>
<script setup>
import { onMounted, onUnmounted } from "vue";
import debounce from "lodash.debounce";

// Import Vuex store
import { useStore } from "vuex";
import { userSession as userSessionNamespace } from "@/store/namespaces.js";

const store = useStore();

const saveLatestMoveTimestamp = () => {
  const timestamp = Date.now();
  store.commit(`${userSessionNamespace}/setLatestMoveTimestamp`, timestamp);
};

// Create a debounced version to avoid excessive calls
const debouncedSaveLatestMoveTimestamp = debounce(
  saveLatestMoveTimestamp,
  2000
);

const setupActivityListeners = () => {
  window.addEventListener("mousemove", debouncedSaveLatestMoveTimestamp);
  window.addEventListener("touchmove", debouncedSaveLatestMoveTimestamp, {
    passive: true,
  });
  // Leaving these here just in case we want to add them later
  // window.addEventListener('mousedown', debouncedSaveLatestMoveTimestamp);
  // window.addEventListener('keydown', debouncedSaveLatestMoveTimestamp);
  // window.addEventListener("touchstart", debouncedSaveLatestMoveTimestamp, {
  //   passive: true,
  // });
  // window.addEventListener("scroll", debouncedSaveLatestMoveTimestamp, {
  //   passive: true,
  // });
  // resetIdleTimeout(); // Initial call to start the timer
};

const removeActivityListeners = () => {
  window.removeEventListener("mousemove", debouncedSaveLatestMoveTimestamp);
  window.removeEventListener("touchmove", debouncedSaveLatestMoveTimestamp);
  // window.removeEventListener('mousedown', debouncedSaveLatestMoveTimestamp);
  // window.removeEventListener('keydown', debouncedSaveLatestMoveTimestamp);
  // window.removeEventListener("touchstart", debouncedSaveLatestMoveTimestamp);
  // window.removeEventListener("scroll", debouncedSaveLatestMoveTimestamp);
  // clearTimeout(idleTimeout.value);
};

onMounted(() => {
  setupActivityListeners();
});

onUnmounted(() => {
  removeActivityListeners();
});
</script>
